import React, { Fragment } from "react";

const FooterBox = (props) => {
    const { title, children } = props;

    return (
        <Fragment>
            {title && <h1 className="title has-text-light">{title}</h1>}
            {children}
        </Fragment>
    );
}

export default FooterBox;
